<template>
  <div class="form-checkbox" :style="style">
    <span @click="inputClick" v-if="$store.state.assigningIndexes" class="tab-index" :style="tabOrderStyle">
      {{ ($store.getters.templateTabOrder(id) > -1) ? $store.getters.templateTabOrder(id) : '?' }}
    </span>

    <span
      @click="toggleCheck"
      @contextmenu="inputClick"
      class="checkbox-wide"
      :id="id"
      :style="inputStyle"
      style="position: absolute;top:0;left:0;width:100%;height:100%;"
      :data-model="model">

      <img
        v-if="value === 'on'"
        style="position: absolute;top:0;left:0;width:100%;height:100%;"
        :draggable="checked"
        src="static/checkmark.svg"
      >
    </span>
    <!-- <input v-else  :style="checkStyle" :id="id" class="checkbox-custom" :name="id" type="checkbox" :tabindex="$store.getters.templateTabOrder(id)" v-model="checked"> -->
  </div>
</template>

<script>
  export default {
    name: 'form-checkbox',

    data () {
      return {
        checked: false,
        valueModel: ''
      }
    },

    props: [
      'id',
      'width',
      'height',
      'left',
      'top',
      'model',
      'tabOrder',
      'value',
      'model',
      'listOfficialModels'
    ],

    watch: {
      model (val) {
        this.valueModel = val
      }
    },

    computed: {
      style () {
        let styleStr = 'position: absolute;'
        styleStr += 'width: ' + this.width + 'px;'
        styleStr += 'height: ' + this.height + 'px;'
        styleStr += 'left: ' + this.left + 'px;'
        styleStr += 'top: ' + this.top + 'px;'
        return styleStr
      },

      checkStyle () {
        let marginScales = {
          1: 0,
          2: 5,
          3: 10,
          4: 15,
          5: 20,
          6: 25,
          7: 30,
          8: 35,
          9: 40,
          10: 45,
          11: 50
        }
        return 'transform: scale(' +
          this.$store.state.pageScale +
          ');margin:' +
          marginScales[this.$store.state.pageScale] +
          'px;' +
          'position:absolute;top:0;left:0;'
      },

      tabOrderStyle () {
        let tabStyleStr = ''
        tabStyleStr += 'width: ' + 20 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'height: ' + 20 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'font-size: ' + 14 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'left: -' + 25 * this.$store.state.pageScale + 'px;'
        return tabStyleStr
      },

      inputStyle () {
        return this.model !== '' &&
          this.listOfficialModels.length > 0 &&
          this.listOfficialModels.map(a => a.model).indexOf(this.valueModel) === -1
            ? 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;outline:red solid 1px;'
            : 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;'
      }
    },

    mounted () {
      this.valueModel = this.model
    },

    methods: {
      toggleCheck () {
        const highlighted = document.querySelectorAll('.id-highlight')
        for (const highlight of highlighted) {
          highlight.classList.remove('id-highlight')
        }

        let chGroupKey = this.$store.getters.checkboxGroup(this.id)

        if (this.value === 'on') this.checked = false
        else this.checked = true

        this.$store.commit('setCheckboxGroupCheck', {
          id: this.id,
          checked: this.checked,
          chGroupKey
        })

        this.$store.dispatch('saveTemplate')

        this.$store.commit('setCurrentTemplateName', 'global')
        this.$store.commit('setCurrentTemplateName', 'default')

        this.focusInput()
      },

      inputClick (e) {
        e.preventDefault()
        this.$bus.emit('openFieldMenu', {
          id: this.id,
          pos: { x: e.pageX, y: e.pageY },
          tabOrder: this.tabOrder
        })
      },

      focusInput () {
        this.$bus.emit('scrollToElement', this.id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  input[type=checkbox] {
    position: relative;
    top: 0;
    left: 0;
    z-index: 10;
    outline-offset: -1px;
    cursor: pointer;
    &:hover {
      outline: green 3px solid;
    }
  }

  .checkbox-wide {
    position: relative;
    outline: black 1px solid;
    outline-offset: -1px;
    cursor: pointer;
    &:hover {
      outline: green 3px solid;
    }
  }

  .tab-index {
    user-select: none;
    position: absolute;
    top: -50%;
    left: -25px;
    width: 22px;
    height: 22px;
    min-width: 22px;
    min-height: 22px;
    background-color: #5E738B;
    color: #FFF;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    border: 2px solid #333;

    &:hover {
      outline: 3px dashed blue;

      &~span {
        outline: 2px dashed blue !important;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/inputs/FormCheckbox.vue